import { Typography } from "@mui/material";

import HNSColors from "../../../../../ui library/HNSColors";
import { STRINGS } from "../../config/strings";
import { getBackgroundColor } from "../../helper/functions";
import { useProviderSearchStore } from "../../store/providerSearchStore";

export default function CustomMarkerInfo({ data }) {
  const { address: source, initAddress, showCustomSearch } = useProviderSearchStore();

  const inNetwork = data?.inNetwork ? STRINGS.IN_NETWORK : STRINGS.OUT_NETWORK;
  const receivingClients = data?.receivingClients ? STRINGS.RECEIVING_CLIENTS : STRINGS.NOT_RECEIVING_CLIENTS;
  const name = data?.name;
  const providerTypes = Array.isArray(data?.providerTypes)
    ? data.providerTypes.map((pt) => pt.name).join(", ")
    : "";
  const address = data?.address?.raw;
  const distance = data?.distance;
  const sourceLocation = (source ?? initAddress)?.label;

  return (
    <div className="flex flex-col gap-2 p-1 w-60">
      <Typography style={{ color: getBackgroundColor(data) }} className="text-[14px]">
        {inNetwork}{" "}
        <span style={{ color: HNSColors.neutrals[100] }} className="text-[12px]">
          {` - ${receivingClients}`}
        </span>
      </Typography>
      <Typography className="text-[10px]" style={{ fontWeight: 600 }}>
        {name}
      </Typography>
      <Typography className="text-[10px]" style={{ color: HNSColors.neutrals[500] }}>
        {providerTypes}
      </Typography>
      <Typography className="text-[10px]" style={{ color: HNSColors.neutrals[500] }}>
        {address}
      </Typography>
      <Typography className="text-[10px]">
        {`${distance} miles${!showCustomSearch ? " from " : ""}`}
        <span style={{ color: HNSColors.primary[500] }}>{sourceLocation}</span>
      </Typography>
    </div>
  );
}
